import { render } from "./CardSearchEntries.vue?vue&type=template&id=496983a6"
import script from "./CardSearchEntries.vue?vue&type=script&lang=js"
export * from "./CardSearchEntries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__